module.exports = __webpack_public_path__ + "static/media/NBMDA Logo.43ce5578.jpg";